import { useQuery } from "@tanstack/react-query";
import { API_URL_GET_ORDER_DETAILS } from "../../../api";
import { retailerFetch } from "../../../retailerFetch";
import { OrderDetails } from "../../../types/models";

const fetchOrderDetails = async (orderId: string): Promise<OrderDetails> => {
    const response = await retailerFetch(API_URL_GET_ORDER_DETAILS(orderId));
    if (!response.ok) {
        throw new Error("Kunne ikke hente ordredetaljer. Prøv igjen senere.");
    }
    return response.json();
};

export const useOrderDetailsQuery = (orderId: string) =>
    useQuery({
        queryKey: ["orderDetails", orderId],
        queryFn: () => fetchOrderDetails(orderId),
        enabled: Boolean(orderId),
        retry: false,
    });
